export default __webpack_public_path__ + "static/media/22.a8071779.webp";